import { useEffect, useRef, useState } from "react";
import axios from "axios";
import "./OnboardingEmployeesList.css";
import { useNavigate } from "react-router-dom";
import { format } from 'date-fns';

const OnboardingEmployeesList = () => {
  const [submitted, setSubmitted] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const userId = storedUser?.userId;
  const effectRan = useRef(false);
  useEffect(() => {
    const fetchSubmitted = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/personal-info/status`,
          {
            params: { status: "WAITING_FOR_ONBOARDING" },
          }
        );
        // API returns array, set to empty array if undefined
        setSubmitted(response.data ?? []);
      } catch (err) {
        console.error("Failed to load submitted applications", err);
        setSubmitted([]);
      } finally {
        setLoading(false);
      }
    };
    if (!effectRan.current) {
      fetchSubmitted();
    }
    return ()=>{
      effectRan.current= true;
    }


  }, []);

  const handleClick = (app) => {
    navigate("/onboardingEmployeeDetails", { state: { application: app } });
  };

  return (
    <div>
      <div className="submitted-table">
        <h2>Onboarding Employees List</h2>
        <div className="submitted-header">
          <div className="submitted-col">Full Name</div>
          <div className="submitted-col">Submission Date and Time</div>
          <div className="submitted-col">Updated By</div>
          <div className="submitted-col">Status</div>
          <div className="submitted-col">Action</div>
        </div>

        {loading ? (
          <div>Loading...</div>
        ) : submitted.length === 0 ? (
          <div>No onboarding employees found.</div>
        ) : (
          submitted.map((app) => {
            const personalInfo = app.personalInformation || {};
            const formattedDateTime = personalInfo.updatedDate
              ? format(new Date(personalInfo.updatedDate), "dd-MM-yyyy, hh:mm a")
              : "—";

            return (
              <div key={personalInfo.id || app.id} className="submitted-row">
                <div className="submitted-col">
                  {`${personalInfo.givenName || ""} ${personalInfo.surname || ""}`}
                </div>
                <div className="submitted-col">{formattedDateTime}</div>
                <div className="submitted-col">{app.filledByName || "N/A"}</div>
                <div className="submitted-col">
                  {personalInfo.recordStatus
                    ? personalInfo.recordStatus.charAt(0).toUpperCase() +
                    personalInfo.recordStatus.slice(1).toLowerCase()
                    : "N/A"}
                </div>
                <div className="submitted-col">
                  <button
                    className="submitted-view-button"
                    onClick={() => handleClick(app)}
                  >
                    Onboarding
                  </button>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default OnboardingEmployeesList;